import { Component, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { RouterLink } from '@angular/router';
import { RolleDatasource } from '@features/roller/rolle.datasource';

@Component({
  selector: 'app-roller-grid',
  imports: [
    TableModule,
    RouterLink,
    TableRowDirective,
    ButtonModule,
    ToolbarModule
  ],
  templateUrl: './roller-grid.component.html',
  styleUrl: './roller-grid.component.css'
})
export class RollerGridComponent {
  datasource = inject(RolleDatasource);
  data = this.datasource.data;
}
